module.exports = __webpack_public_path__ + "media/custom/images/img42-b859b763ebc18f946f8549bfeb628329.jpg";